import { styled } from "@mui/material";
import { StyledPopup } from "../Popup.styled";

export const StyledHeader = styled("div")`
  display: flex;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
  > span {
    line-height: ${({ theme }) => theme.wsc.typography.header5.lineHeight};
  }
`;

export const StyledPopupWithoutFooter = styled(StyledPopup)`
  .MuiDialogContent-root {
    padding: 0px;
    margin: 0px;
  }
`;

export const StyledCloseButton = styled("div")`
  margin-left: auto;
`;
